import React from "react";

import "./index.scss";

function index({ theme, active, data, type, linkHandler }) {
  return (
    <div className="list-container">
      <ul className={`card list ${theme}`}>
        {data.map(filter => (
          <li
            className={filter.name === active ? "active" : ""}
            onClick={linkHandler}
            key={filter.id}
            type={type}
          >
            {filter.name}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default index;
